import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getDaysLeft } from '../../helpers/timeline';
import styles from '../../styles/views/components/DaysStatus.module.scss';

const DaysStatus = ({
  currentStageDate,
  leftWrapper,
  rightWrapper,
  extraClass,
}) => {
  const daysLeft = useMemo(() => getDaysLeft(currentStageDate), [currentStageDate]);
  const isOverdue = daysLeft < 0;
  const currentStageStyles = useMemo(() => {
    if (daysLeft < 0) return styles.red;
    if (daysLeft < 7) return styles.orange;
    return '';
  }, [daysLeft]);

  return (
    <span className={`${styles.daysLeft} ${currentStageStyles} ${extraClass}`}>
      {leftWrapper}
      {Math.abs(daysLeft)} {t('timelineSection.days', { ns: i18next.Namespace.COMMON })} {isOverdue ? t('timelineSection.overdue', { ns: i18next.Namespace.COMMON }) : t('timelineSection.left', { ns: i18next.Namespace.COMMON })}
      {rightWrapper}
    </span>
  );
};

DaysStatus.propTypes = {
  currentStageDate: PropTypes.string.isRequired,
  rightWrapper: PropTypes.string,
  leftWrapper: PropTypes.string,
  extraClass: PropTypes.string,
};

DaysStatus.defaultProps = {
  leftWrapper: '',
  rightWrapper: '',
  extraClass: '',
};

export default DaysStatus;
